import { LayoutConstants } from '../../../../js/constants/LayoutConstants';

export function isGeminiSimplifyTemplate() {
  return (
    window.masterLayoutName.toLowerCase() === LayoutConstants.WEBSITE_GEMINI &&
    window.menuStyleId === '6'
  );
}
